import { CarFleetViewScheduleRecord } from '@navio/nsdk';
import { NoddiBadge } from 'noddi-ui-web';
import { BadgeColumnContainer } from './BadgeColumnContainer';

type Props = {
  fleetSchedule: CarFleetViewScheduleRecord | null | undefined;
  noneLabel: string;
};

export const FleetScheduleCell = ({ fleetSchedule, noneLabel }: Props) => {
  if (!fleetSchedule) {
    return (
      <BadgeColumnContainer>
        <NoddiBadge variant='outline'>{noneLabel}</NoddiBadge>
      </BadgeColumnContainer>
    );
  }
  return <span className='text-sm font-medium'>{fleetSchedule.fleetScheduleName}</span>;
};
